import React from "react";
import { FaFacebookF, FaYoutube, FaInstagram } from "react-icons/fa6";
import "./FooterPage.css";
import Logo from "../Assets/logos/ample-house-logo.png";

const FooterPage = () => {

  const year = new Date().getFullYear();

  return (
    <footer className="footer">

      <div className="footer-container">

        {/* BRAND .....*/}
        <div className="footer-brand">
          <img src={Logo} alt="JourneyMan Logo" className="footer-logo" />

          <p className="footer-tagline">
            Edu-Care. Communi-Care. <br/>
            Lead Self. Lead Others. Lead Systems.
          </p>
        </div>

        {/* LINKS */}
        <div className="footer-links">
          <h4>Explore</h4>

          <a href="/">Home</a>
          <a href="/about-us">About Us</a>
          <a href="/ample-productions">Ample Productions</a>
          <a href="/ample-event">Ample Event</a>
          <a href="/ample-academy">Ample Academy</a>
          <a href="/ample-publications">Ample Publications</a>
    
          <a href="/contact-us">Contact Us</a>
        </div>

        {/* CONTACT */}
        <div className="footer-contact">
          <h4>Contact</h4>

          <p>Email: office@amplehouse.net</p>
          <p>Phone: +233 256 687 881</p>
          <p>Accra, Ghana</p>
        </div>

        {/* SOCIAL */}
        <div className="footer-social">
          <h4>Follow Us</h4>

          <div className="social-icons">
            <a href="#" target="_blank" rel="noopener noreferrer">
              <FaFacebookF />
            </a>

            <a href="#" target="_blank" rel="noopener noreferrer">
              <FaYoutube />
            </a>

            <a href="#" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
          </div>

        </div>

      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">
        <p className="footer-copy">
          © {year} Ample House. All Rights Reserved.
        </p>

        {/* <p className="developer-credit">
          Powered By: Unichem Creative Department
        </p> */}
      </div>

    </footer>
  );
};

export default FooterPage;